import Image from "next/image";
import useMedia from "hooks/use-media";
import { homeBanner, homeAbout, homeWhyBtc, homeBtcAppre } from "data/text";
import TextParagraph from "./TextParagraph";
import styles from "./SectionTextProductServiceV2.module.scss";
import useSite from "hooks/use-site";
import defaultPostImage from "../../../public/260x230.png";
import { customPostTypePathBySlug } from "lib/posts";
import Link from "next/link";

const SectionTextProductServiceV2 = ({
    section = null,
    pageTemplate = null,
    content = null,
    btcPrice = 0,
    datas = [],
    options = {},
}) => {
    const isSm = useMedia(`(max-width: 768px)`);
    const isLg = useMedia(`(min-width: 1024px)`);
    const { locale } = useSite();
    let lang = locale.toLowerCase();
    const text = {
        th: {
            product: "PRODUCT &",
            service: "SERVICE",
        },
        en: {
            product: "PRODUCT &",
            service: "SERVICE",
        },
    };
    const _renderSectionText = () => {
        return (
            <div className={styles.sectionTopHome}>
                <h1 className={styles.textWrap}>
                    <span className={styles.textHighlight}>
                        {text[lang].product}
                    </span>
                    <span className={styles.textHighlightWhite}>
                        {text[lang].service}
                    </span>
                </h1>
            </div>
        );
    };

    return <div className={styles.sectionWrap}>{_renderSectionText()}</div>;
};

export default SectionTextProductServiceV2;
